<template>
  <HiddenField :name="name" :modelValue="agilityCode" />
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from "vue";
import HiddenField from "./HiddenField.vue";

type Props = {
  prefix: string;
};

let interval: ReturnType<typeof setInterval> | null = null;
let intervalCounter = 0;

const agilityCode = ref("");
const props = defineProps<Props>();
const name = computed<string>(
  () => (props.prefix ? `${props.prefix}-` : "") + "dream_agility_ref"
);

onMounted(() => {
  if (window.daReferenceCode) {
    agilityCode.value = window.daReferenceCode;
    return;
  }

  interval = setInterval(() => {
    intervalCounter++;

    if (window.daReferenceCode) {
      clearInterval();
      agilityCode.value = window.daReferenceCode;
      return;
    }

    if (intervalCounter > 50) {
      clearInterval();
      console.warn("dream agility ref not found.");
    }
  }, 250);
});

onUnmounted(() => {
  if (interval) {
    clearInterval();
  }
});

function clearInterval() {
  if (interval) {
    window.clearInterval(interval);
  }
}
</script>
